<template>
  <div class="full-height">
    <foobar-header></foobar-header>
    <intro></intro>
    <section-intro :title="$t('message.title.main.privacy_and_license')"></section-intro>
    <privacy-policies></privacy-policies>
    <foobar-footer></foobar-footer>
  </div>
</template>

<script>
  import Intro from '@/components/partials/IntroLarge'
  import FoobarHeader from '@/components/partials/Header'
  import FoobarFooter from '@/components/partials/Footer'
  import PrivacyPolicies from '@/components/privacy/PrivacyPolicies'
  import SectionIntro from '@/components/partials/SectionIntroZeroOne'

  export default {
    components: {
      Intro,
      FoobarFooter,
      FoobarHeader,
      PrivacyPolicies,
      SectionIntro
    }
  }
</script>



// WEBPACK FOOTER //
// PrivacyAndLicense.vue?61c9c973